import axios from './../../function/axiosInstance'
import extract from './../../function/extract'
import { getURLFromAPIType } from '../../function/getEditorApiEndpoint'

export const getIntegrationsList = async ({
  pageSize,
  currentPage,
  companyId
}: {
  pageSize: number
  currentPage: number
  companyId: string
}): Promise<ApiResponse> => {
  try {
    const url = `/integrations?page_size=${pageSize}&current_page=${currentPage}&company_id=${companyId}&type_filter=all`
    const response = await axios.get(url)
    return extract.data(response)
  } catch (error) {
    return extract.error(error)
  }
}

export const deleteIntegration = async ({
  accountId,
  companyId
}: {
  accountId: string
  companyId: string
}): Promise<ApiResponse> => {
  try {
    const url = `/integrations/delete-account?account_id=${accountId}&company_id=${companyId}`
    const response = await axios.delete(url)
    return extract.data(response)
  } catch (error) {
    return extract.error(error)
  }
}

export const publishIntegration = async ({
  companyId,
  accountId,
  assignmentId,
  categories,
  tags
}: {
  companyId: string
  assignmentId: string
  accountId: string
  categories: string[]
  tags: string[]
}): Promise<ApiResponse> => {
  try {
    const url = `/integrations/publish-assignment?account_id=${accountId}&assignment_id=${assignmentId}&company_id=${companyId}`
    const response = await axios.post(url, {
      categories,
      tags
    })
    return extract.data(response)
  } catch (error) {
    return extract.error(error)
  }
}

export const publishItem = async ({
  companyId,
  accountId,
  itemId,
  categories,
  tags
}: {
  companyId: string
  itemId: string
  accountId: string
  categories: string[]
  tags: string[]
}): Promise<ApiResponse> => {
  try {
    const url = `/integrations/publish-item?account_id=${accountId}&item_id=${itemId}&company_id=${companyId}`
    const response = await axios.post(url, {
      categories,
      tags
    })
    return extract.data(response)
  } catch (error) {
    return extract.error(error)
  }
}
